import { CaseMembersPanel } from '@/components/cases/CaseMembersPanel'
import { useAuth } from '@/contexts/AuthContext'
import { isSuperadmin } from '@/lib/roles'
import {
  useAddMember,
  useCaseMembers,
  useRemoveMember,
  useUpdateMemberRole,
} from './hooks/useCaseMembers'

/** Owner-controlled sharing panel for a case. Only owners (and superadmins) see
 * the management controls; other members see a read-only member list. */
export function CaseMembersConnected({ caseId }: { caseId: string }) {
  const { user } = useAuth()
  const { members, isLoading } = useCaseMembers(caseId)
  const { addMember, adding } = useAddMember(caseId)
  const { updateRole } = useUpdateMemberRole(caseId)
  const { removeMember } = useRemoveMember(caseId)

  const myRole = members.find(m => m.user_id === user?.id)?.role
  const canManage = myRole === 'owner' || isSuperadmin(user?.role)

  return (
    <CaseMembersPanel
      members={members}
      loading={isLoading}
      canManage={canManage}
      adding={adding}
      onAdd={(username, role) => addMember({ username, role })}
      onChangeRole={(userId, role) => updateRole({ userId, role })}
      onRemove={removeMember}
    />
  )
}
